import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FundraisingPurchaseInfo, TicketOrderTableView } from '../../_models/fundraising/TicketOrder';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { FundraisingService } from '../../_services/fundraising/fundraising.service';
import { DialogService } from '../../_services/dialog.service';
import { Cue5050 } from '../../_models/fundraising/Cue5050';
import { forkJoin } from 'rxjs';




@Component({
    selector: 'ticket-history-management',
    templateUrl: './ticket-history-management.component.html',
    styleUrls: ['../../_shared/base.management.component.css']
  })

  export class TicketHistoryManagementComponent implements OnInit {
    public loading = true;
    public form: FormGroup;

    public ticketOrders: TicketOrderTableView[] = [];

    public events: Cue5050[] = [];
    public selectedEvent: Cue5050;

    public searchText: string = '';
    public startIndex: number = 0;

    public page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'eventName',
        orderDir: 'desc'
    }
    public itemsPerPage: number = 20;

    private bsModalRef: any;

    constructor(
        private spinner: NgxSpinnerService,
        private cue5050Service: Cue5050Service,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef) {}


    ngOnInit(){
        this.initialGetData();
    }

    initialGetData(){
        this.spinner.show();
        const eventsObservable = this.cue5050Service.getAll();
        const ordersObservable = this.cue5050Service.getAllTicketOrders(0, 
                                                                        this.page.limit,
                                                                        this.selectedEvent ? this.selectedEvent.cue5050Id : 0,
                                                                        this.searchText,
                                                                        this.page.orderBy,
                                                                        this.page.orderDir);
        forkJoin([eventsObservable, ordersObservable])
            .subscribe(data => {
                this.spinner.hide();
                this.events = data[0].cue5050s;

                this.ticketOrders = data[1].ticketOrders;
                this.page.count = data[1].count;
            }, error => {
                this.dialogService.alert("Oops something went wrong...", error.error, this.viewRef);
                this.spinner.hide();
            })
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }){
        this.page.offset = pageInfo.offset;
        this.reloadTable();
    }

    sortCallback(sortInfo: { sorts: {dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }){
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.reloadTable();
    }

    reloadTable(){
        this.spinner.show();
        this.cue5050Service.getAllTicketOrders(this.page.offset * this.page.limit, 
                                               this.page.limit, this.selectedEvent ? this.selectedEvent.cue5050Id : 0, 
                                               this.searchText, this.page.orderBy, 
                                               this.page.orderDir)
            .subscribe(res => {
                this.ticketOrders = res.ticketOrders;
                this.page.count = res.count;
                if (this.page.offset * this.page.limit > this.page.count){
                    this.page.offset = 0;
                    this.reloadTable();
                }
                this.spinner.hide();
            }, error => {
                this.dialogService.alert("Oops something went wrong...", error.error, this.viewRef);
                this.spinner.hide();
            })
    }

    refundOrder (order: TicketOrderTableView) {

        this.dialogService.confirm('Are you sure?', 'Clicking confirm will refund the ticket order.', this.viewRef)
            .then(
                (res) => {
                    if (res) {

                        this.spinner.show();

                        this.cue5050Service.refundOrder(order.referenceNumber, order.paymentIntentId)
                            .subscribe(
                                _ => {

                                    this.spinner.hide();
                                    this.dialogService.alert('Success!', 'Ticket order successfully refunded.', this.viewRef);
                                    this.reloadTable();
                                }
                                ,error => {

                                    this.spinner.hide();
                                    this.dialogService.alert('Uh oh!', 'Something went wrong trying to refund that order.', this.viewRef);
                                }
                            )
                    }
                }
            )
    }

    resendReceipt(order: TicketOrderTableView){
        this.spinner.show();
        this.cue5050Service.resendReceipt(order.referenceNumber)
            .subscribe(_ => {
                this.spinner.hide();
                this.dialogService.alert('Success!', 'Receipt successfully resent.', this.viewRef);
            }, error => {
                console.log(error);
                this.spinner.hide();
                this.dialogService.alert('Uh oh!', `Something went wrong trying to resend the receipt: ${error.error}`, this.viewRef);
            })
    }

    convertPaymentTypeString(type: string){
        return type === 'card_present' ? 'Card Onsite' : type === 'card' ? 'Online' : type === 'cash' ? 'Cash' : '';
    }
  }